import { GasModalService } from './gas-modal.service';
import { GasModalComponent } from './modal/gas-modal.component';

export abstract class GasBaseModal<T> {

  public modal: GasModalComponent<T>;
  public props: Partial<T>;

  constructor(
    public gasModalService: GasModalService<T>,
  ) { }

  public closeModal(id: string): void {
    this.gasModalService.closeModal(id);
  }

  public saveDataAndCloseModal(data: T): void {
    this.gasModalService.saveAndClose(data, this.modal.id);
  }
}
